import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import { Toaster as Sonner } from '@/components/ui/sonner';
import { Toaster } from '@/components/ui/toaster';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ROUTES } from '@/config/routes';
import { MasterclassProvider, useMasterclass } from '@/contexts/MasterclassContext';
import { AppHeader } from '@/modules/app-header';
import { ReadOnlyProvider } from '@/modules/read-only';

import { useAppVersion } from './hooks/useAppVersion';
import { RouteObserver } from './modules/google-analytics/analytic/RouteObserver';
import Auth from './pages/Auth';
import CaseSelection from './pages/CaseSelection';
import Index from './pages/Index';
import NotFound from './pages/NotFound';
import Stats from './pages/Stats';

const AppLayout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { userProfile } = useMasterclass();
  const showHeader = location.pathname !== ROUTES.AUTH;

  return (
    <div className="flex flex-col md:h-screen">
      {showHeader && <AppHeader userProfile={userProfile} />}
      <main className="flex-1 md:overflow-hidden">{children}</main>
    </div>
  );
};

const App = () => {
  useAppVersion();
  return (
    <MasterclassProvider>
      <ReadOnlyProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <RouteObserver />
            <AppLayout>
              <Routes>
                <Route path={ROUTES.HOME} element={<Navigate to={ROUTES.CASES} replace />} />
                <Route path={ROUTES.AUTH} element={<Auth />} />
                <Route path={ROUTES.CASES} element={<CaseSelection />} />
                <Route path={ROUTES.CASE_DETAIL} element={<Index />} />
                <Route path={ROUTES.STATS} element={<Stats />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
              </Routes>
            </AppLayout>
          </BrowserRouter>
        </TooltipProvider>
      </ReadOnlyProvider>
    </MasterclassProvider>
  );
};

export default App;
